import { PublicationDate } from '#components/Article/PublicationDate';
import type { FeedTeaser } from '#domains/resolver/board-section-data';

import { ArticleItemTitleLink } from '../../../Article/Items/ArticleItemTitleLink';

import styles from './FeedItem.module.scss';

type Props = {
	onClick?: () => void;
	teaser: FeedTeaser;
	className?: string;
};

export function FeedItem({ teaser, onClick, className = '' }: Props) {
	if (teaser.type === 'empty') {
		return null;
	}

	return (
		<article className={`${styles.wrapper} ${className}`} onClick={onClick}>
			<header className={`${styles.header} ${!teaser.publicationDate ? styles.withVerticalPadding : ''}`}>
				{teaser.publicationDate && (
					<section className={styles.meta}>
						<PublicationDate className="body6" publicationDate={teaser.publicationDate} />
					</section>
				)}

				<ArticleItemTitleLink as="h3" className={styles.title} headingClassName="body1" path={teaser.href}>
					{teaser.title}
				</ArticleItemTitleLink>
			</header>
		</article>
	);
}
